<template>
  <d2-container>
    <template slot="header">
      <el-form
        :inline="true"
        :model="searchForm"
        ref="searchForm"
        size="mini"
        style="margin-bottom: -18px;"
      >
        <el-form-item
          label="商铺名称"
        >
          <el-input
            v-model="searchForm.agentName"
            placeholder="商铺名称"
            style="width: 100px;"
          />
        </el-form-item>
        <el-form-item>
          <el-date-picker
                  v-model="dateRange"
                  :picker-options="pickerOptions"
                  type="daterange"
                  range-separator="~"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"    width="150">

          </el-date-picker>

        </el-form-item>

        <el-form-item>
          <el-select
                  class="filter-item"
                  v-model="searchForm.shType"
                  placeholder="审核状态"
                  width="50"
          >
            <el-option
                    v-for="item in typeOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="handleSearchFormSubmit"
          >
            <d2-icon name="search" /> 查询
          </el-button>
        </el-form-item>

        <el-form-item>
          <el-button @click="handleSearchFormReset">
            <d2-icon name="refresh" /> 重置
          </el-button>
        </el-form-item>
      </el-form>
    </template>
    <el-button
      v-if="multipleSelection.length>0"
      type="danger"
      size="mini"
      icon="el-icon-delete"
      @click="batchDel"
    >
      删除
    </el-button>
    <el-table
      :data="tableData"
      v-loading="loading"
      size="small"
      stripe
      highlight-current-row
      style="width: 100%;"
      @selection-change="handleSelectionChange"
      @sort-change="handleSortChange"
    >

      <el-table-column
        type="selection"
        width="55"
      >
      </el-table-column>
      <el-table-column
        label="商铺名称"
      >
        <template slot-scope="scope">
          {{scope.row.agentname}}
        </template>
      </el-table-column>

      <el-table-column
        label="图片"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.image_url!=null && scope.row.image_url!=''">
            <img :src= "getImgUrl(scope.row)" style="width: 100px;height: 100px; "/>
          </div>

        </template>
      </el-table-column>
      <el-table-column
        label="评论内容"
      >
        <template slot-scope="scope">
          {{scope.row.comment_content}}
        </template>
      </el-table-column>
      <el-table-column
              label="评论用户"
      >
        <template slot-scope="scope">
          {{scope.row.anonymous}}
        </template>
      </el-table-column>
      <el-table-column
              label="服务态度"
      >
        <template slot-scope="scope">
          {{scope.row.service_attitude}}
        </template>
      </el-table-column>
      <el-table-column
              label="商家评分"
      >
        <template slot-scope="scope">
          {{scope.row.merchant_ratings}}
        </template>
      </el-table-column>
      <el-table-column
              label="商家总分"
      >
        <template slot-scope="scope">
          {{scope.row.merchant_total}}
        </template>
      </el-table-column>
      <el-table-column
              label="评论时间"
      >
        <template slot-scope="scope">
          {{scope.row.commentary_times}}
        </template>
      </el-table-column>
      <el-table-column
              label="审核状态"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.sh_type=='0'">
            未审核
          </div>
          <div v-else-if="scope.row.sh_type=='1'">
            已审核
          </div>

        </template>
      </el-table-column>
      <el-table-column
            label="审核时间"
    >
      <template slot-scope="scope">
        {{scope.row.sh_times}}
      </template>
    </el-table-column>
      <el-table-column
        fixed="right"
        label="操作"
        align="center"
        width="230"
      >
        <template slot-scope="scope">
          <el-button type="primary" plain size="mini"  v-if="scope.row.sh_type=='0'"  @click="shgl(scope.row)">审核</el-button>
          <el-button type="primary" plain size="mini"  @click="openViewForm(scope.row)">详情</el-button>
          <el-button type="primary" plain size="mini"    @click="del(scope.row)">删除</el-button>
        </template>
      </el-table-column>

    </el-table>
    <template slot="footer">
      <el-pagination
        :current-page="page.current"
        :page-size="page.size"
        :total="page.total"
        :page-sizes="[1,10,50,100, 200, 300, 400]"
        layout="total, sizes, prev, pager, next, jumper"
        style="margin: -10px;"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </template>
    <view-form
            :oneclass="oneclass"
            v-model="viewFormVisible"
            @submit="getTableData"
    />

  </d2-container>
</template>
<script>
import * as memberService from '@/api/sys/member'
import util from '@/libs/util.js'
import viewForm from './viewForm'
export default {
  name: 'MembergglPage',
  components: { viewForm },
  data () {
    return {
      searchForm: {
        fxtel: '',
        legal: '',
        userCode: ''
      },
      loading: false,
      tableData: [],
      multipleSelection: [],
      dateRange: [],
      pickerOptions: {},
      typeOptions: [
        {
          value: '1',
          label: '已审核'
        },
        {
          value: '0',
          label: '未审核'
        }
      ],
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      sort: {
        prop: '',
        order: ''
      },
      oneclass: {},
      agentid: '',
      viewFormVisible: false
    }
  },
  mounted () {
    this.getTableData()
  },
  methods: {
    dateConversion (value) {
      if (value != null && value != '') {
        var d = new Date(value)
        //  var date = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate() + ' ' + d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds();
        var date = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate()
        console.info('===========date=========' + date)
        return date
      } else {
        return ''
      }
    },
    getImgUrl (row) {
      return 'https://xgkj-1304765860.cos.ap-shanghai.myqcloud.com/' + row.image_url
    },
    getTableData () {
      let query = {
        pageIndex: this.page.current,
        pageSize: this.page.size,
        sortBy: this.sort.prop,
        dl_type: util.cookies.get('dl_type'),
        xt_id: util.cookies.get('xt_id'),
        agentid: util.cookies.get('agentid'),
        start_time: this.dateConversion(this.dateRange[0]),
        end_time: this.dateConversion(this.dateRange[1]),
        descending: this.sort.order === 'descending',
        filter: this.searchForm
      }
      memberService.getCommentPageList(query).then(data => {
        this.tableData = data.rows
        this.page.total = data.totalCount
      })
    },
    handleSearchFormSubmit () {
      this.getTableData()
    },
    handleSearchFormReset () {
      this.$refs.searchForm.resetFields()
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    handleSortChange (val) {
      this.sort.prop = val.prop
      this.sort.order = val.order
      this.getTableData()
    },
    handleSizeChange (val) {
      this.page.size = val
      this.getTableData()
    },
    handleCurrentChange (val) {
      this.page.current = val
      this.getTableData()
    },
    openViewForm (oneclass) {
      this.oneclass = oneclass
      this.viewFormVisible = true
    },
    batchDel () {
      this.$confirm('确认删除？', '确认信息', {
        distinguishCancelAndClose: true,
        confirmButtonText: '删除',
        cancelButtonText: '取消'
      }).then(() => {
        memberService
          .delCommentBath({
            ids: JSON.stringify(this.multipleSelection.map(s => s.id))
          })
          .then(() => {
            this.getTableData()
          })
      })
    },
    shgl (oneclass) {
      let msg = '审核通过'
      this.$confirm('确认' + msg + '操作？', '确认信息', {
        distinguishCancelAndClose: true,
        confirmButtonText: msg,
        cancelButtonText: '取消'
      }).then(() => {
        memberService.updateComment({ id: oneclass.id }).then(() => {
          this.getTableData()
        })
      })
    },
    del (oneclass) {
      this.$confirm('确认删除？', '确认信息', {
        distinguishCancelAndClose: true,
        confirmButtonText: '删除',
        cancelButtonText: '取消'
      }).then(() => {
        memberService.delComment({ id: oneclass.id }).then(() => {
          this.getTableData()
        })
      })
    }
  }
}
</script>
